import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
} from "@mui/material";

import {
  FaCashRegister,
} from "react-icons/fa";

import ProsetPopup from "./components/ProsetPopup";
import KuyumcuLeftSideNavbar from "./components/KuyumcuLeftSideNavbar";
// import PremiumBackground from "./components/PremiumBackground";

import ProsetDataGrid from "./components/KuyumcuDataGrid";
import YetkisizErisim from "./components/YetkisizErisim";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableViewIcon from "@mui/icons-material/TableView";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import axiosInstance from "../../api/axiosInstance";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx-js-style";

import { getUserId } from "../../utils/getUserId";
import { useNavigate } from "react-router-dom";

import logo from "../../img/kucuk-logo-beyaz.png";
import Roboto from "../../fonts/Roboto-Regular-normal.js";

import "./css/KuyumcuMainPage.css";
import "./css/KuyumcuKasaPage.css";

import { formatNumberTR } from "./utils/numberFormat";

const KuyumcuKasaPage = () => {
  const navigate = useNavigate();

  const userId = getUserId();
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  useEffect(() => {
    if (!userId || !token) navigate("/login");
  }, [userId, token, navigate]);

  // ==========================
  // YETKİLER
  // ==========================
  const [yetkiler, setYetkiler] = useState(null); // null=loading, []=geldi
  const [yetkisiz, setYetkisiz] = useState(false);

  const yetkiSet = useMemo(() => new Set(yetkiler || []), [yetkiler]);

  const hasPermission = (code) => {
    // Üst kullanıcı bypass: backend "ALL" döndürür
    if (yetkiSet.has("ALL")) return true;
    return yetkiSet.has(code);
  };

  const loadYetkiler = async () => {
    if (!userId) return;
    try {
      const resp = await axiosInstance.get("/me/yetki-kodlari", {
        params: { girisYapanUserId: userId },
      });
      setYetkiler(resp.data || []);
    } catch (e) {
      console.error("Yetkiler alınamadı:", e);
      setYetkiler([]); // güvenli fallback
    }
  };

  // ==========================
  // STATE
  // ==========================
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().slice(0, 10)
  );

  // Sayfa açılır açılmaz "Bugün" filtresi seçili gelsin
  const [preset, setPreset] = useState("TODAY");

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // ==========================
  // BAĞIMSIZ NAKİT İŞLEM POPUP
  // ==========================
  const [bagimsizPopupOpen, setBagimsizPopupOpen] = useState(false);
  const [bagimsizEditMode, setBagimsizEditMode] = useState(false);
  const [bagimsizEditingId, setBagimsizEditingId] = useState(null);

  const [bagimsizForm, setBagimsizForm] = useState({
    tarih: (() => {
      // datetime-local default: YYYY-MM-DDTHH:mm
      const d = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    })(),
    islemTur: "",
    birim: "TL",
    miktar: "",
    aciklama: "",
  });

  const resetBagimsizForm = () => {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    setBagimsizForm({
      tarih: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )}T${pad(d.getHours())}:${pad(d.getMinutes())}`,
      islemTur: "",
      birim: "TL",
      miktar: "",
      aciklama: "",
    });
  };

  const openBagimsizCreatePopup = () => {
    setBagimsizEditMode(false);
    setBagimsizEditingId(null);
    resetBagimsizForm();
    setBagimsizPopupOpen(true);
  };

  const openBagimsizEditPopup = (row) => {
    // sadece bağımsız (hesapId=0) işlemler düzenlenebilir
    setBagimsizEditMode(true);
    setBagimsizEditingId(row.id);

    const toDatetimeLocal = (value) => {
      // value ISO ise: YYYY-MM-DDTHH:mm:ss -> YYYY-MM-DDTHH:mm
      if (!value) return "";
      // backend bazen "2026-02-23T10:15:00" gibi gelir
      if (typeof value === "string" && value.includes("T")) {
        return value.slice(0, 16);
      }
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    setBagimsizForm({
      tarih: toDatetimeLocal(row.tarih),
      islemTur: row.islemTur || "",
      birim: row.birim || "TL",
      miktar: row.miktar ?? "",
      aciklama: row.aciklama || "",
    });

    setBagimsizPopupOpen(true);
  };

  const closeBagimsizPopup = () => setBagimsizPopupOpen(false);

  const saveBagimsizNakitIslem = async () => {
    if (!userId) return;

    const miktarNum = Number(String(bagimsizForm.miktar).replace(",", "."));
    if (!bagimsizForm.islemTur) {
      alert("İşlem Türü seçiniz.");
      return;
    }
    if (!bagimsizForm.birim) {
      alert("Birim seçiniz.");
      return;
    }
    if (!Number.isFinite(miktarNum) || miktarNum <= 0) {
      alert("Miktar 0'dan büyük olmalı.");
      return;
    }

    try {
      // Bu işlem hiçbir hesaba bağlı değil → hesapId=0
      // Update için de aynı hesapId=0 gitmeli
      const dto = {
        id: bagimsizEditMode ? bagimsizEditingId : undefined,
        hesapId: 0,
        kullaniciId: userId,
        tarih: bagimsizForm.tarih, // LocalDateTime için uygun
        islemTur: bagimsizForm.islemTur,
        birim: bagimsizForm.birim,
        miktar: miktarNum,
        aciklama: bagimsizForm.aciklama || "",
        altinKarsiligiMi: false,
      };

      if (bagimsizEditMode) {
        await axiosInstance.put("/islemler", dto, {
          headers: { "X-User-Id": userId },
        });
      } else {
        await axiosInstance.post("/islemler", dto, {
          headers: { "X-User-Id": userId },
        });
      }

      closeBagimsizPopup();
      await loadAllIslemler();
    } catch (e) {
      console.error("Bağımsız nakit işlem kaydedilemedi:", e);
      alert(
        e?.response?.data?.message ||
          e?.response?.data ||
          "Bağımsız nakit işlem kaydedilemedi."
      );
    }
  };

  const deleteBagimsizIslem = async (row) => {
    if (!row?.id) return;
    if (!window.confirm("Bu bağımsız işlemi silmek istiyor musunuz?")) return;

    try {
      await axiosInstance.delete(`/islemler/${row.id}`, {
        headers: { "X-User-Id": userId },
      });
      await loadAllIslemler();
    } catch (e) {
      console.error("Bağımsız işlem silinemedi:", e);
      alert(
        e?.response?.data?.message ||
          e?.response?.data ||
          "Bağımsız işlem silinemedi."
      );
    }
  };

  // BAKİYELER
  const [bakiyeTL, setBakiyeTL] = useState(0);
  const [bakiyeUSD, setBakiyeUSD] = useState(0);
  const [bakiyeEUR, setBakiyeEUR] = useState(0);
  const [bakiyeZiynet, setBakiyeZiynet] = useState({
    "Yeni ATA": 0,
    "Yeni YARIM": 0,
    "Yeni ÇEYREK": 0,
    "Eski ATA": 0,
    "Eski YARIM": 0,
    "Eski ÇEYREK": 0,
  });

  // Responsive
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ==========================
  // DATA LOAD
  // ==========================
  const loadAllIslemler = async () => {
    if (!userId) return;
    try {
      const resp = await axiosInstance.get("/islemler/kasa");
      const data = resp.data || [];
      setRows(data);
      hesaplaBakiyeler(data);
    } catch (e) {
      console.error("Kasa işlemleri alınamadı:", e);
    }
  };

  // 1) userId gelince yetkileri çek
  useEffect(() => {
    if (!userId) return;
    loadYetkiler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  // 2) yetkiler geldikten sonra sayfa erişimi kontrol et
  useEffect(() => {
    if (yetkiler === null) return;

    if (!hasPermission("KASA_VIEW")) {
      setYetkisiz(true);
      return;
    }

    setYetkisiz(false);
    loadAllIslemler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yetkiler]);

  // ==========================
  // BAKİYE HESABI
  // ==========================
  const hesaplaBakiyeler = (list) => {
    let _tl = 0,
      _usd = 0,
      _eur = 0;

    let z = {
      "Yeni ATA": 0,
      "Yeni YARIM": 0,
      "Yeni ÇEYREK": 0,
      "Eski ATA": 0,
      "Eski YARIM": 0,
      "Eski ÇEYREK": 0,
    };

    list.forEach((i) => {
      const miktar = Number(i?.miktar) || 0;
      if (!miktar) return;

      const isVerildi =
        i.islemTur === "ALTIN_VERILDI" ||
        i.islemTur === "NAKIT_VERILDI" ||
        i.islemTur === "ZIYNET_VERILDI" ||
        i.islemTur === "NAKIT_ISLEM_GRAM_VERILDI";

      const sign = isVerildi ? -1 : +1;

      if (i.birim === "TL") _tl += miktar * sign;
      if (i.birim === "USD") _usd += miktar * sign;
      if (i.birim === "EUR") _eur += miktar * sign;

      if (i.islemTur?.includes("ZIYNET") && z[i.stokAdi] !== undefined) {
        z[i.stokAdi] += miktar * sign;
      }
    });

    setBakiyeTL(_tl);
    setBakiyeUSD(_usd);
    setBakiyeEUR(_eur);
    setBakiyeZiynet(z);
  };

  // ===============================
  //  MOBİL FORMAT FONKSİYONLARI
  // ===============================
  const formatMobileDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yy = String(d.getFullYear()).slice(2);
    return `${dd}/${mm}/${yy}`;
  };

  const formatMobileIslemTur = (value) => {
    if (value === "NAKIT_ALINDI") return "Alındı";
    if (value === "NAKIT_VERILDI") return "Verildi";
    if (value === "NAKIT_ISLEM_GRAM_ALINDI") return "(Gr) Alındı";
    if (value === "NAKIT_ISLEM_GRAM_VERILDI") return "(Gr) Verildi";
    return "";
  };

  const onlyNakit = (list) =>
    list.filter(
      (r) =>
        r.islemTur === "NAKIT_ALINDI" ||
        r.islemTur === "NAKIT_VERILDI" ||
        r.islemTur === "NAKIT_ISLEM_GRAM_ALINDI" ||
        r.islemTur === "NAKIT_ISLEM_GRAM_VERILDI"
    );

  // TARİH FİLTRELEME
  useEffect(() => {
    const toDateOnly = (d) => {
      const dt = new Date(d);
      dt.setHours(0, 0, 0, 0);
      return dt;
    };

    let out = rows;
    if (!rows.length) {
      setFilteredRows([]);
      return;
    }

    const today = toDateOnly(new Date());

    if (preset === "DATE") {
      out = rows.filter((i) => i.tarih?.slice(0, 10) === selectedDate);
    } else if (preset === "TODAY") {
      out = rows.filter(
        (i) => toDateOnly(i.tarih).getTime() === today.getTime()
      );
    } else if (preset === "LAST7") {
      const limit = new Date();
      limit.setDate(limit.getDate() - 7);
      out = rows.filter((i) => toDateOnly(i.tarih) >= toDateOnly(limit));
    } else if (preset === "LAST30") {
      const limit = new Date();
      limit.setDate(limit.getDate() - 30);
      out = rows.filter((i) => toDateOnly(i.tarih) >= toDateOnly(limit));
    } else if (preset === "PREV_MONTH") {
      let year = today.getFullYear();
      let pm = today.getMonth() - 1;
      if (pm < 0) {
        pm = 11;
        year--;
      }
      out = rows.filter((i) => {
        const d = new Date(i.tarih);
        return d.getFullYear() === year && d.getMonth() === pm;
      });
    } else if (preset === "ALL") out = rows;

    setFilteredRows(out);
  }, [rows, preset, selectedDate]);

  // TAM TARİH FORMAT (PC)
  const formatDate = (value) => {
    if (!value) return "";
    if (screenWidth < 600) return formatMobileDate(value);
    const d = new Date(value);
    return (
      d.toLocaleDateString("tr-TR") +
      " " +
      d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })
    );
  };

  // ENUM GÖSTERİMİ
  const formatIslemTurKasa = (value) => {
    if (!value) return "";
    if (value === "NAKIT_ISLEM_GRAM_ALINDI") return "(Gr) Nakit Alındı";
    if (value === "NAKIT_ISLEM_GRAM_VERILDI") return "(Gr) Nakit Verildi";
    if (value === "NAKIT_ALINDI") return "Nakit Alındı";
    if (value === "NAKIT_VERILDI") return "Nakit Verildi";
    return value;
  };

  const formatNumber = (value) => {
    if (value == null || value === "") return "";
    const num = Number(value);
    if (isNaN(num)) return value;
    const parts = num.toFixed(2).split(".");
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const decimalPart = parts[1];
    return `${integerPart},${decimalPart}`;
  };

  const getKasaBorcAlacak = (row, type) => {
    const tur = row.islemTur;

    const isGramAlindi = tur === "NAKIT_ISLEM_GRAM_ALINDI";
    const isGramVerildi = tur === "NAKIT_ISLEM_GRAM_VERILDI";

    if (isGramAlindi) {
      return type === "ALACAK" ? formatNumber(row.miktar) : "0,00";
    }

    if (isGramVerildi) {
      return type === "BORC" ? formatNumber(row.miktar) : "0,00";
    }

    if (type === "BORC") return formatNumber(row.borc);
    if (type === "ALACAK") return formatNumber(row.alacak);

    return "";
  };

  const canCreate = hasPermission("KASA_CREATE");
  const canUpdate = hasPermission("KASA_UPDATE");
  const canDelete = hasPermission("KASA_DELETE");

  // ===============================
  //        KOLONLAR
  // ===============================
  let columns = [];
  let rowsToShow = onlyNakit(filteredRows);

  const showActions = canUpdate || canDelete;

  if (screenWidth < 600) {
    rowsToShow = onlyNakit(filteredRows);

    columns = [
      {
        field: "tarih",
        headerName: "Tarih",
        width: 90,
        renderCell: (p) => formatMobileDate(p.row.tarih),
      },
      {
        field: "islemTur",
        headerName: "Tür",
        width: 80,
        renderCell: (p) => formatMobileIslemTur(p.row.islemTur),
      },
      {
        field: "borc",
        headerName: "Verilen",
        width: 70,
        renderCell: (p) => getKasaBorcAlacak(p.row, "BORC"),
      },
      {
        field: "alacak",
        headerName: "Alınan",
        width: 70,
        renderCell: (p) => getKasaBorcAlacak(p.row, "ALACAK"),
      },
      {
        field: "birim",
        headerName: "Br",
        width: 55,
      },
    ];

    if (showActions) {
      columns.push({
        field: "actions",
        headerName: "",
        width: 90,
        sortable: false,
        filterable: false,
        renderCell: (p) => {
          const r = p.row;
          const bagimsizMi = Number(r?.hesapId) === 0;

          if (!bagimsizMi) return null;

          return (
            <Box display="flex" gap={0.5}>
              {canUpdate && (
                <Tooltip title="Düzenle">
                  <IconButton
                    size="small"
                    onClick={() => openBagimsizEditPopup(r)}
                    sx={{
                      color: "#b8860b",
                      "&:hover": { color: "#d4a017" },
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

              {canDelete && (
                <Tooltip title="Sil">
                  <IconButton
                    size="small"
                    onClick={() => deleteBagimsizIslem(r)}
                    sx={{
                      color: "#c62828",
                      "&:hover": { color: "#ff2b2b" },
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      });
    }
  } else {
    columns = [
      {
        field: "tarih",
        headerName: "Tarih",
        flex: 1,
        renderCell: (p) => formatDate(p.row.tarih),
      },
      {
        field: "islemTur",
        headerName: "Tür",
        flex: 1,
        renderCell: (p) => formatIslemTurKasa(p.row.islemTur),
      },
      {
        field: "borc",
        headerName: "Verilen",
        flex: 1,
        renderCell: (p) => getKasaBorcAlacak(p.row, "BORC"),
      },
      {
        field: "alacak",
        headerName: "Alınan",
        flex: 1,
        renderCell: (p) => getKasaBorcAlacak(p.row, "ALACAK"),
      },
      {
        field: "birim",
        headerName: "Birim",
        flex: 0.8,
      },
      {
        field: "aciklama",
        headerName: "Açıklama",
        flex: 2,
      },
    ];

    if (showActions) {
      columns.push({
        field: "actions",
        headerName: "",
        flex: 0.7,
        sortable: false,
        filterable: false,
        renderCell: (p) => {
          const r = p.row;
          const bagimsizMi = Number(r?.hesapId) === 0;

          if (!bagimsizMi) return <span style={{ opacity: 0.4 }}>-</span>;

          return (
            <Box display="flex" gap={0.5}>
              {canUpdate && (
                <Tooltip title="Düzenle">
                  <IconButton
                    size="small"
                    onClick={() => openBagimsizEditPopup(r)}
                    sx={{
                      color: "#b8860b",
                      "&:hover": { color: "#d4a017" },
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              )}

              {canDelete && (
                <Tooltip title="Sil">
                  <IconButton
                    size="small"
                    onClick={() => deleteBagimsizIslem(r)}
                    sx={{
                      color: "#c62828",
                      "&:hover": { color: "#ff2b2b" },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      });
    }
  }

  // ============================================================
  //                         PDF RAPOR
  // ============================================================
  const downloadPDF = () => {
    const doc = new jsPDF();

    doc.addFileToVFS("Roboto-Regular.ttf", Roboto);
    doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    doc.setFont("Roboto", "normal");

    const imgWidth = 40;
    const imgHeight = 17;
    const pageWidth = doc.internal.pageSize.getWidth();
    const centerX = (pageWidth - imgWidth) / 2;

    doc.addImage(logo, "PNG", centerX, 5, imgWidth, imgHeight);
    doc.setFontSize(16);
    doc.text("KASA RAPORU", pageWidth / 2, 40, { align: "center" });

    const tableData = rowsToShow.map((r) => [
      formatDate(r.tarih),
      formatIslemTurKasa(r.islemTur),
      r.birim,
      r.miktar,
      r.aciklama || "",
    ]);

    autoTable(doc, {
      startY: 50,
      styles: {
        font: "Roboto",
        fontSize: 10,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        font: "Roboto",
        fontStyle: "bold",
        fontSize: 11,
        fillColor: [60, 141, 188],
        textColor: "#fff",
      },
      columnStyles: { 4: { halign: "left", cellWidth: 70 } },
      head: [["Tarih", "Tür", "Birim", "Miktar", "Açıklama"]],
      body: tableData,
    });

    doc.save("kasa_raporu.pdf");
  };

  // ============================================================
  //                        EXCEL RAPOR
  // ============================================================
  const downloadExcel = () => {
    const data = rowsToShow.map((r) => ({
      Tarih: formatDate(r.tarih),
      Tür: formatIslemTurKasa(r.islemTur),
      Birim: r.birim || "",
      Miktar: r.miktar ?? "",
      Açıklama: r.aciklama || "",
    }));

    const ws = XLSX.utils.json_to_sheet(data);

    ["A1", "B1", "C1", "D1", "E1"].forEach((cell) => {
      if (!ws[cell]) return;
      ws[cell].s = {
        fill: { patternType: "solid", fgColor: { rgb: "1E7D44" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "center", vertical: "center" },
      };
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Kasa Raporu");
    XLSX.writeFile(wb, "kasa_raporu.xlsx");
  };

  // ============================================================
  //                          UI
  // ============================================================
  return (
    <div className="main-container">

{/*       <PremiumBackground /> */}
      <KuyumcuLeftSideNavbar />

      <div className="content">
        {yetkiler === null ? (
          <h2 style={{ color: "#b8860b" }}>Yetkiler kontrol ediliyor...</h2>
        ) : yetkisiz ? (
          <YetkisizErisim sayfaAdi="Kasa" />
        ) : (
          <>
            <h1 style={{ color: "#b8860b", marginBottom: 20 }}><FaCashRegister /> KASA</h1>

            {/* BAKİYE PANELİ */}
            <Box className="bakiye-container">
              <div className="bakiye-row">
                <div className="bakiye-box">
                  <label>TL</label>
                  <div className="bakiye-input">
                    ₺ <input readOnly value={formatNumberTR(bakiyeTL)} />
                  </div>
                </div>

                <div className="bakiye-box">
                  <label>USD</label>
                  <div className="bakiye-input">
                    💵 <input readOnly value={formatNumberTR(bakiyeUSD)} />
                  </div>
                </div>

                <div className="bakiye-box">
                  <label>EUR</label>
                  <div className="bakiye-input">
                    💶 <input readOnly value={formatNumberTR(bakiyeEUR)} />
                  </div>
                </div>
              </div>
            </Box>

            {/* TARİH VE FİLTRELER */}
            <Box
              mt={3}
              mb={2}
              display="flex"
              gap={1.5}
              flexWrap="wrap"
              alignItems="center"
              sx={{
                background: "rgba(255,255,255,0.5)",
                padding: "12px 15px",
                borderRadius: "12px",
                backdropFilter: "blur(6px)",
                border: "1px solid rgba(184,134,11,0.3)",
              }}
            >
              <TextField
                type="date"
                label="Tarih"
                InputLabelProps={{ shrink: true }}
                value={selectedDate}
                onChange={(e) => {
                  setPreset("DATE");
                  setSelectedDate(e.target.value);
                }}
                sx={{
                  minWidth: 150,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                  },
                }}
              />

              {[
                { key: "TODAY", label: "Bugün" },
                { key: "LAST7", label: "Son 7 Gün" },
                { key: "LAST30", label: "Son 30 Gün" },
                { key: "PREV_MONTH", label: "Geçen Ay" },
                { key: "ALL", label: "Tüm Zamanlar" },
              ].map((btn) => (
                <Button
                  key={btn.key}
                  variant="outlined"
                  onClick={() => setPreset(btn.key)}
                  sx={{
                    padding: "6px 14px",
                    borderRadius: "20px",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    textTransform: "none",
                    border:
                      preset === btn.key
                        ? "2px solid #b8860b"
                        : "1px solid #b8860b",
                    color: preset === btn.key ? "#fff" : "#b8860b",
                    background: preset === btn.key ? "#edbe4a" : "transparent",
                    boxShadow:
                      preset === btn.key
                        ? "0 0 8px rgba(184,134,11,0.6)"
                        : "none",
                    transition: "0.25s",
                    "&:hover": {
                      background:
                        preset === btn.key
                          ? "#d4a017"
                          : "rgba(184,134,11,0.15)",
                      borderColor: "#d4a017",
                      color: preset === btn.key ? "#fff" : "#d4a017",
                    },
                  }}
                >
                  {btn.label}
                </Button>
              ))}

              {canCreate && (
                <Button
                  variant="contained"
                  onClick={openBagimsizCreatePopup}
                  sx={{
                    marginLeft: "auto",
                    background: "#b8860b",
                    "&:hover": { background: "#d4a017" },
                    borderRadius: "10px",
                    paddingX: 3,
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                >
                 Bağımsız Nakit İşlem Ekle
                </Button>
              )}
            </Box>

            {/* TABLO */}
            <div style={{ height: 520 }}>
              <ProsetDataGrid rows={rowsToShow} columns={columns} pageSize={10} />
            </div>

            {/* PDF & EXCEL */}
            <Box
              mb={2}
              mt={2}
              display="flex"
              gap={2}
              flexWrap="wrap"
              justifyContent="flex-end"
              width="100%"
            >
              <Button
                variant="contained"
                startIcon={<PictureAsPdfIcon />}
                sx={{
                  background: "#1e7d44",
                  "&:hover": { background: "#23984f" },
                  textTransform: "none",
                  fontWeight: "bold",
                  paddingX: 2,
                  paddingY: "6px",
                  borderRadius: "8px",
                  color: "white",
                }}
                onClick={downloadPDF}
              >
                PDF Raporu
              </Button>

              <Button
                variant="contained"
                startIcon={<TableViewIcon />}
                sx={{
                  background: "#1e7d44",
                  "&:hover": { background: "#23984f" },
                  textTransform: "none",
                  fontWeight: "bold",
                  paddingX: 2,
                  paddingY: "6px",
                  borderRadius: "8px",
                  color: "white",
                }}
                onClick={downloadExcel}
              >
                Excel Raporu
              </Button>
            </Box>
          </>
        )}

        <ProsetPopup
          open={bagimsizPopupOpen}
          title={bagimsizEditMode ? "Bağımsız Nakit İşlem Düzenle" : "Bağımsız Nakit İşlem Ekle"}
          onCancel={closeBagimsizPopup}
          onSave={saveBagimsizNakitIslem}
        >
{/*         <PremiumBackground /> */}
          <TextField
            label="Tarih"
            type="datetime-local"
            InputLabelProps={{ shrink: true }}
            value={bagimsizForm.tarih}
            onChange={(e) =>
              setBagimsizForm((p) => ({ ...p, tarih: e.target.value }))
            }
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel id="bagimsiz-islem-tur-label">İşlem Türü</InputLabel>
            <Select
              labelId="bagimsiz-islem-tur-label"
              label="İşlem Türü"
              value={bagimsizForm.islemTur}
              onChange={(e) =>
                setBagimsizForm((p) => ({ ...p, islemTur: e.target.value }))
              }
            >
              <MenuItem value="NAKIT_ALINDI">Nakit Alındı</MenuItem>
              <MenuItem value="NAKIT_VERILDI">Nakit Verildi</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="bagimsiz-birim-label">Birim</InputLabel>
            <Select
              labelId="bagimsiz-birim-label"
              label="Birim"
              value={bagimsizForm.birim}
              onChange={(e) =>
                setBagimsizForm((p) => ({ ...p, birim: e.target.value }))
              }
            >
              <MenuItem value="TL">TL</MenuItem>
              <MenuItem value="USD">USD</MenuItem>
              <MenuItem value="EUR">EUR</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Miktar"
            value={bagimsizForm.miktar}
            onChange={(e) =>
              setBagimsizForm((p) => ({ ...p, miktar: e.target.value }))
            }
            placeholder="Örn: 15000,50"
            fullWidth
          />

          <TextField
            label="Açıklama"
            value={bagimsizForm.aciklama}
            onChange={(e) =>
              setBagimsizForm((p) => ({ ...p, aciklama: e.target.value }))
            }
            fullWidth
          />
        </ProsetPopup>
      </div>
    </div>
  );
};

export default KuyumcuKasaPage;